import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Loader from "./Components/Loader"; // New Component
import SEO from "./Components/SEO";

// Pages
import FloatingButtons from "./Components/FloatingButtons";
import Hero from "./Components/Hero";
import AboutUs from "./Components/AboutUs.jsx";
import Contactus from "./Components/contactus";
import Servicepage from "./Components/Servicepage";
import PatientCare from "./Components/PatientCare";
import BabyCare from "./Components/BabyCare";
import HouseMaid from "./Components/HouseMaid";
import CookingMaid from "./Components/CookingMaid";
import DriverService from "./Components/DriverService";
import HomeCleaningService from "./Components/HomeCleaningService";
import Japamaid from "./Components/japamaid.jsx";
import ScrollToTop from "./Components/ScrollToTop.jsx";
// import PageTitle from "./Components/PageTitle.jsx";
import FAQ from "./Components/FAQ";
import Blog from "./Components/Blog";
import BlogDetails from "./Components/BlogDetails";

import PrivacyPolicy from "./Components/PrivacyPolicy";
import TermsConditions from "./Components/TermsConditions";

// Logic Wrapper to handle Route Changes
function AppContent() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show loader when route starts changing
    setLoading(true);

    // Hide loader after a short delay (e.g., 800ms)
    const timer = setTimeout(() => {
      setLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <>
      {/* GLOBAL LOADER */}
      {loading && <Loader />}

      <FloatingButtons />
      <ScrollToTop />
      <SEO />

      <div className={`App ${loading ? "content-blur" : ""}`}>
        <Header />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Hero />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/contact" element={<Contactus />} />
            <Route path="/services" element={<Servicepage />} />
            <Route path="/services/patient-care-service-in-mumbai" element={<PatientCare />} />
            <Route path="/services/baby-care-service-in-mumbai" element={<BabyCare />} />
            <Route path="/services/house-maid-service-in-mumbai" element={<HouseMaid />} />
            <Route path="/services/cooking-service-in-mumbai" element={<CookingMaid />} />
            <Route path="/services/driver-service-in-mumbai" element={<DriverService />} />
            <Route path="/services/home-cleaning-service-in-mumbai" element={<HomeCleaningService />} />
            <Route path="/services/japa-maid-service-in-mumbai" element={<Japamaid />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetails />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            
          </Routes>
        </main>

        <Footer />
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;